var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClouds = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-clouds")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.094,7.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,8.338,4.84a.249.249,0,0,1-.22.173,5.5,5.5,0,0,0-5,6.61.248.248,0,0,0,.318.188q.312-.1.634-.164a.249.249,0,0,0,.177-.143,8.4,8.4,0,0,1,.74-1.322.253.253,0,0,0,.041-.11A3.5,3.5,0,0,1,8.948,7.029l.064,0c.23-.085.465-.161.7-.226a1,1,0,0,0,.348-.612A5,5,0,0,1,20,7c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959,3,3,0,0,1-.088,5.263c.029.177.051.356.069.537a.244.244,0,0,0,.074.155,6.467,6.467,0,0,1,.734.853.251.251,0,0,0,.334.067,5,5,0,0,0,.49-8.193Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.094,15.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,5.338,12.84a.249.249,0,0,1-.22.173A5.5,5.5,0,0,0,5.5,24H16a5,5,0,0,0,3.094-8.926ZM16,22H5.5a3.5,3.5,0,1,1,.448-6.971A1,1,0,0,0,7.064,14.2,5,5,0,0,1,17,15c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959A3,3,0,0,1,16,22Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClouds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clouds.76280b86.svg";
export { ForwardRef as ReactComponent };